/** Sites (Demo Mode: Preview) - the master, permanent operational record for a site once it
 * exists, distinct from Site Development (the launch/change project workflow used to get a
 * site ready). This page embeds the real, fully-functional Store Portfolio list unmodified
 * (real API data, search/filter/create/download/upload) since "Sites" maps to the existing
 * Store concept - this satisfies "Sites is the operational master data" while avoiding a
 * second, divergent implementation of store search/listing. Drilling into a row opens the
 * nested Site Detail screen (see SiteDetail.tsx), which combines the real Store edit form
 * with the fuller estate-management record (customer/contract, zones, equipment, compliance,
 * etc.) as tabs. Create/edit navigation is routed into the estate-management nested detail
 * screen rather than the standalone /stores/edit page so the extra tabs are reachable. */

import StoresPage from '../Stores';

const Sites = () => (
  <StoresPage
    createPath="/estate-management/sites/create"
    editBasePath="/estate-management/sites/edit"
    requireInstanceAndMarket
  />
);

export default Sites;